export default __webpack_public_path__ + "b8c5b224a115bf1fbe15def9bea254e3.png";